import React from 'react';
import { useTranslation } from 'react-i18next';
import ErrorBoundaryHolder from './Styles/errorBoundaryStyle';
import { Row, Col, Button } from 'antd';
import imageRobot from "../images/not-found-img3.png";
import logoWhite from "../images/logo-latinad-white.png";

const CriticalErrorFallbackComponent = () => {
  const { t } = useTranslation();

  const handleGoBackAndReload = () => {
    if (window.history.length > 1) {
      window.history.back();
      setTimeout(() => {
        window.location.reload();
      }, 100);
    } else {
      window.location.href = '/';
    }
  };

  return (
    <ErrorBoundaryHolder>
      <div className="error-container">
        <Row>
          <Col 
            xs={{ span: 24, order: 2 }} 
            sm={{ span: 10, order: 1 }} 
            md={10} 
            lg={10} 
            xl={11}
          >
            <div className="leftSideContainer">
              <img src={logoWhite} className="logLatinadWhite" alt="" />
              <h1>{t('An unexpected error has occurred')}</h1>
              <p>{t('To continue browsing, please press the button to return to the previous page. We are working to improve your experience on our platform. Thank you for your understanding!')}</p>
              <Button onClick={handleGoBackAndReload} className='go-back-btn'>
                {t('Resume browsing')}
              </Button>
            </div>
          </Col>
          <Col 
            xs={{ span: 24, order: 1 }} 
            sm={{ span: 14, order: 2 }} 
            md={14} 
            lg={14} 
            xl={13} 
          >
            <img src={imageRobot} className="imageBg" alt="" />
          </Col>
        </Row>
      </div>
    </ErrorBoundaryHolder>
  );
};

export default CriticalErrorFallbackComponent;